import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { CollectionModel } from 'collection';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent implements OnInit, OnDestroy {
  @Input() collection: CollectionModel;
  @Input() shortList: boolean = false;
  @Input() showLoader: boolean = true;

  text: string = marker('Showing {{ perPage }} to {{ perPageTo }} of {{ total }} items');
  textTranslateParams: {
    perPage: number;
    perPageTo: number;
    total: number;
  };

  perPageSize: number;
  itemsPerPageFrom: number;
  itemsPerPageTo: number;

  private _destroyed$ = new Subject();

  nextPage(page) {
    if (page) {
      this.collection.setParams('page', page);
    }
    this.collection.search();
  }

  collectionSubscription(): void {
    if (this.collection) {
      this.collection.onLoad$.pipe(takeUntil(this._destroyed$)).subscribe((res) => {
        this.initProperties();
      });
    }
  }

  private initProperties(): void {
    this.perPageSize = this.collection?.meta?.perPage;
    this.itemsPerPageFrom =
      this.collection?.meta?.currentPage * this.collection?.meta?.perPage - (this.collection?.meta?.perPage - 1);
    this.itemsPerPageTo =
      this.collection?.meta?.currentPage === this.collection?.meta?.pageCount
        ? this.collection?.meta?.totalCount
        : this.collection?.meta?.currentPage * this.collection?.meta?.perPage;

    this.textTranslateParams = {
      perPage: this.itemsPerPageFrom,
      perPageTo: this.itemsPerPageTo,
      total: this.collection?.meta?.totalCount
    };

    this._cdr.detectChanges();
  }

  ngOnInit() {
    this.initProperties();
    this.collectionSubscription();
  }

  ngOnDestroy() {
    this._destroyed$.next(true);
    this._destroyed$.complete();
  }

  constructor(private _cdr: ChangeDetectorRef) {}
}
